
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, Setting, SettingState, TibboDataType, FeatureType,
} from '@appblocks/codegeneration/types';
import ZephyrUtils from '@appblocks/platforms/ZephyrUtils';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class GPIO extends BaseFeature {
    constructor() {
        super();
        this.id = 'gpio';
        this.name = 'GPIO Pin';
        this.singleInstance = false;
        this.featureType = FeatureType.PERIPHERAL;
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.INTEGER,
                required: true,
                default: 'peripheral',
            },
            {
                id: 'BUILTINID',
                name: 'Built In ID',
                settingType: SettingType.HIDDEN,
                readonly: true,
                default: '',
            },
            {
                id: 'BUILTIN',
                name: 'Built In',
                settingType: SettingType.BOOLEAN,
                readonly: true,
                default: '0',
            },
            {
                id: 'PIN',
                name: 'Pin',
                settingType: SettingType.PIN,
                required: true,
                meta: 'GPIO',
                default: '',
            },
            {
                id: 'DIRECTION',
                name: 'Direction',
                settingType: SettingType.OPTION,
                default: '',
                required: true,
                options: [
                    {
                        name: 'None',
                        value: '',
                    },
                    {
                        name: 'Input',
                        value: '1',
                    },
                    {
                        name: 'Output',
                        value: '0',
                    },
                ],
            },
            {
                id: 'PULL',
                name: 'Bias',
                settingType: SettingType.OPTION,
                default: '',
                required: true,
                options: [
                    {
                        name: 'None',
                        value: '',
                    },
                    {
                        name: 'Pull Down',
                        value: 'down',
                    },
                    {
                        name: 'Pull Up',
                        value: 'up',
                    },
                ],
            },
            {
                id: 'STATE',
                name: 'Initial State',
                settingType: SettingType.OPTION,
                default: '',
                required: true,
                options: [
                    {
                        name: 'None',
                        value: '',
                    },
                    {
                        name: 'high',
                        value: '1',
                    },
                    {
                        name: 'low',
                        value: '0',
                    },
                ],
            },
            {
                id: 'DRIVE',
                name: 'Drive',
                settingType: SettingType.OPTION,
                default: '',
                required: true,
                options: [
                    {
                        name: 'None',
                        value: '',
                    },
                    {
                        name: 'Open Drain',
                        value: '1',
                    },
                    {
                        name: 'Open Source',
                        value: '0',
                    },
                ],
            },
            {
                id: 'ACTIVE',
                name: 'Active Level',
                settingType: SettingType.OPTION,
                default: '0',
                required: true,
                options: [
                    // {
                    //     name: 'None',
                    //     value: '',
                    // },
                    {
                        name: 'Active High',
                        value: '1',
                    },
                    {
                        name: 'Active Low',
                        value: '0',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getFlags(): string {
        return ZephyrUtils.getFlags(this);
    }

    getState(settingId: string): SettingState {
        switch (settingId) {
            case 'state':
                return this.getSettingValue('direction') === '1' ? SettingState.DISABLED : SettingState.ENABLED;
            default:
                return SettingState.ENABLED;
        }
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/gpio_type';
    }
}
